<div class="flex w-full flex-wrap border-b border-gray-200">
  <span
    *ngFor="let tab of tabs"
    (click)="setActiveTab(tab.key)"
    class="pb-1 mr-6 lg:pb-3 mb-3 md:mb-0 text-sm font-medium cursor-pointer"
    [ngClass]="{
      'text-purple-600 border-b-2 border-purple-600 font-semibold':
        activeTabKey === tab.key,
      'text-gray-500 hover:text-gray-700': activeTabKey !== tab.key,
    }"
  >
    {{ tab.label }}
  </span>
</div>

<div class="pt-6">
  @if (scrollingMode) {
    <ng-container *ngFor="let tab of tabContents">
      <div #tabContentBlock class="mb-10" [attr.data-tab-key]="tab.tabKey">
        <ng-container [ngTemplateOutlet]="tab.template"></ng-container>
      </div>
    </ng-container>
  } @else {
    <ng-container
      *ngIf="activeTabKey && activeTemplate"
      [ngTemplateOutlet]="activeTemplate"
    ></ng-container>
  }
</div>
